
import Vue from "vue";
import * as _ from "lodash";
import DatepickerFormatted from "../../../common/inputs/DatepickerFormatted.vue";
import showService from "@/services/admin/showService";

export default Vue.extend({
  name: "ConformationShowResultsEntry",
  components: {
    DatepickerFormatted
  },
  data: function() {
    return {
      selectedConformationEntry: null as any,
      selectedConformationEntryDetails: null as any,
      savedConformationEntries: [] as any[],
      calculatedPoints: null as any,

      showDeleteConfirmationDialog: false,
      deletedShowResultId: null,
      showResults: [] as any[],
      persistedShowResults: [] as any[],
      errorMessage: null as any,
      emptyRow: null as any,
      uniqueDogIds: [] as any,
      checkboxStates: [null, true, false],
    };
  },
  methods: {    
    emptyShowResultRow: function(lastPersistedRow: any, showResults: any[]){
      if(!lastPersistedRow){
        if(!!showResults && showResults.length > 0){
          lastPersistedRow = Object.assign({}, showResults[showResults.length - 1]);
        }
      }

      if(!!lastPersistedRow){
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: lastPersistedRow.showDate,
          showTime: lastPersistedRow.showTime,
          judgeId: lastPersistedRow.judgeId,
          categoryId: lastPersistedRow.categoryId,
          competingCount: null,
          score: null,
          scchScore: null,
          isScchMajor: null,
          showId: this.showId,
          pointSchedule: null,
        };
      } else {
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: this.showInfo.defaultDate,
          showTime: null,
          categoryId: null,
          judgeId: (!!this.showInfo.judges && this.showInfo.judges.length == 1) ? this.showInfo.judges[0].id : null,
          score: null,
          scchScore: null,
          isScchMajor: null,
          competingCount: null,
          showId: this.showId,
          pointSchedule: null,
        };
      }
    },  
    reloadData: function() {
      if (this.showId) {
        this.$store.dispatch("changeLoaderStatus",true);

        try {
          showService.getConformationShowResultsSummaryList(this.showId)
          .then((res) => { 
            this.savedConformationEntries = res; 
            this.selectedConformationEntry = null;
          }
          ).finally(() => { });

        showService
            .getShowResultsByShowId(this.showId, 'C')
            .then((res) => {
                this.showResults = _.cloneDeep(res);
                this.persistedShowResults = _.cloneDeep(res);
                this.emptyRow = Object.assign({}, this.emptyShowResultRow(null, res));
            })
            .catch((e) => console.log(e))
            .finally(() => { }); 
          } finally {
            this.$store.dispatch("changeLoaderStatus",false);
          }
      }
    }, 
    row_classes: function(item: any, index: number){
      if (!!item.resultId)
      {
        const index = this.showResults.findIndex(i => i.resultId === item.resultId);
        if(_.isEqual(this.showResults[index], this.persistedShowResults[index])){
          return '';
        }
      } 
      return 'orange  lighten-4';
    },
    saveShowResult: function(item: any, index: any) {
      this.$store.dispatch("changeLoaderStatus",true);
      const isAddingNewRow = !item.resultId;
      showService.updateShowResult(this.showId, 'C', item)
        .then((res) => {
          if(!res.success){
            this.errorMessage = res.messages.join(", ");
            if(isAddingNewRow){
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            }
          } else {
            if(isAddingNewRow){
              this.showResults.unshift(res.showResult);
              this.persistedShowResults = _.cloneDeep(this.showResults);

              this.emptyRow = Object.assign({}, this.emptyShowResultRow(this.emptyRow, this.showResults));
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            } else {
              //in case the dogId value has been changed we need to update the dog name to allow admin to validate data entry
              this.showResults[index] =  Object.assign({}, res.showResult);
              this.persistedShowResults = _.cloneDeep(this.showResults);
            }
            this.errorMessage = null;
          }
        })
        .catch((e) => {
          this.errorMessage = "Changes couldn't be saved. Ensure there are no validation errors before retrying.";
        })
        .finally(() => { this.$store.dispatch("changeLoaderStatus",false);}); 
    },
    deleteShowResult: function(item: any) {
      if(item.resultId) {//if that item has been persisted already
        this.deletedShowResultId = item.resultId;
        this.showDeleteConfirmationDialog = true;
      } else {
        const index = this.showResults.indexOf(item);
        this.showResults.splice(index, 1);
      }
    },
    confirmDelete: function() {
      showService.deleteShowResult(this.showId, this.deletedShowResultId)
      .then((res) => {
        if(!res.success){
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults[index].errors = res.messages.join(", ");
          this.deletedShowResultId = null;
        } else {
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults.splice(index, 1);
          this.persistedShowResults.splice(index, 1);
        }   
      })
      .finally(() => {this.showDeleteConfirmationDialog = false});
    },
    updateDates: function (val: any, key: string, item: any) {
      item[key] = val?.date;
      //workaround to force rerendering after setting up formatted date
      this.$set(this, 'showResults', this.showResults);
    },
    calculatePoints: function() {
      this.$store.dispatch("changeLoaderStatus",true);
      try{
        showService.getConformationShowResultsSummary(this.showId, this.selectedConformationEntry.showDate, this.selectedConformationEntry.showTime, this.selectedConformationEntry.showType)
        .then((res) => { 
          this.selectedConformationEntryDetails = _.cloneDeep(res);
        });

        showService.calculatePointsForConformationShowResults(this.showId, this.selectedConformationEntry.showDate, this.selectedConformationEntry.showTime, this.selectedConformationEntry.showType)
          .then((res: any) =>{ 
            this.calculatedPoints = res;
            this.uniqueDogIds = new Set();
            if(!!this.selectedConformationEntryDetails?.winnerDogId){
              this.uniqueDogIds.add(this.selectedConformationEntryDetails.winnerDogId?.trim());
            }
            if(!!this.selectedConformationEntryDetails?.winnerBitchId){
              this.uniqueDogIds.add(this.selectedConformationEntryDetails.winnerBitchId?.trim());
            }
            if(!!this.selectedConformationEntryDetails?.bestOfBreedId){
              this.uniqueDogIds.add(this.selectedConformationEntryDetails.bestOfBreedId?.trim());
            }
            if(!!this.selectedConformationEntryDetails?.bestOfOppositeSexId){
              this.uniqueDogIds.add(this.selectedConformationEntryDetails.bestOfOppositeSexId?.trim());
            }
            if(!!this.selectedConformationEntryDetails?.selectDogId){
              this.uniqueDogIds.add(this.selectedConformationEntryDetails.selectDogId?.trim());
            }
            if(!!this.selectedConformationEntryDetails?.selectBitchId){
              this.uniqueDogIds.add(this.selectedConformationEntryDetails.selectBitchId?.trim());
            }
          })
      } finally { this.$store.dispatch("changeLoaderStatus",false); };  
    },
  },    
  created: function() {
    this.reloadData();
  },
  watch: {
    showId: function(newVal: String, oldVal: String) {
      if(newVal && newVal != oldVal){
        this.reloadData();
      }
    },    
    "selectedConformationEntry": function(newVal: String, oldVal: String) {
      if(newVal != oldVal){
        this.$set(this, 'selectedConformationEntryDetails', null);
        this.$set(this, 'calculatedPoints', null);
      }
    },
  },
  computed: {
    pointSchedules: function(){
      if(!this.showInfo || !this.showInfo.affiliatePointSchedules)
      {
        return [];
      }

      const uniqueIds = _.uniq(this.showInfo.affiliatePointSchedules.map((ps: any) => ps.id)).filter(id => !!id);
      let ptSched = [] as any[];
      uniqueIds.forEach((x: any) => {
        const matching = this.showInfo.affiliatePointSchedules.filter((ps: any) => ps.id == x);
        const entry = {id: x, displayValue: `${x}: ${matching.map((ps:any) => ps.displayValue).join(", ")}`}
        ptSched.push(entry);
      });
      return ptSched;
    }
  },
  props: {
    showId: { type: String },
    showInfo: {type: Object}
  },
});
